import { couponFormFactory } from "../../../coupon_form_factory";
import { formatterCurrency, getValueWithoutFormat } from "../../../formatters";

export function setupPaymentForm (clientForm, productForm, submitButton, paymentMethod = "card") {
  const formCouponIdHiddenInput = document.getElementById("client_payment_coupon_id");
  const formAmountOffHiddenInput = document.getElementById("client_payment_amount_off");
  const formPercentOffHiddenInput = document.getElementById("client_payment_percent_off");
  const formDiscountAmountHiddenInput = document.getElementById("client_payment_discount_amount");
  const formAmountHiddenInput = document.getElementById("client_payment_amount");
  const formTotalAmountHiddenInput = document.getElementById("client_payment_total_amount");
  const formCountInstallmentsHiddenInput = document.getElementById("client_payment_installments_count");
  const formFixedInstallmentHiddenInput = document.getElementById("client_payment_fixed_installments");

  if (window.coupon_accepted) {
    const { emailInput } = clientForm.inputs;

    const couponElements = {
      formAmountHiddenInput,
      couponInput: document.getElementById("coupon_id"),
      discountAmountSpan: document.getElementById("discount-amount"),
      paymentTotalSpan: document.getElementById("payment-total"),
      clearCouponButton: document.getElementById("clear_coupon"),
      errorSpanContainer: document.getElementById("coupon-container")?.parentElement,
      submitCouponButton: document.getElementById("submit_coupon"),
      emailInput,
      submitButton
    };
    let timeoutRef = null;

    const couponForm = couponFormFactory({
      elements: couponElements,
      productId: productForm.getId()
    });
    if (couponForm && !couponForm.fixedCoupon) {
      // TODO: this is for card payment, should extract and have the variant for pix/nupay here
      /**
       * Update installments options or span
       *
       * @param {string} amount numeric value
       * @param {boolean} [fixedInstallments=false] flag
       */
      const updateInstallments = (amount, fixedInstallments = false) => {
        if (fixedInstallments) {
          // operates over single span element
          const numericValue = Number(formCountInstallmentsHiddenInput.value);
          const formattedInstallmentValue = formatterCurrency.format(
            Number(amount) / numericValue
          );
          showInstallmentsSpan.innerText = `${numericValue}x ${formattedInstallmentValue} sem juros`;
        } else {
          // operate over options elements
          installmentsOptionsElements.forEach(function (item) {
            const numericValue = Number(item.value);
            const formattedInstallmentValue = formatterCurrency.format(
              Number(amount) / numericValue
            );
            item.innerText = `${numericValue}x ${formattedInstallmentValue} sem juros`;
          });
        }
      };

      if (couponForm) {
        /**
         * Handles changes in coupon values
         *
         * @param {{
         *   amount: string
         *   amountOff: number
         *   coupon: string
         *   discountAmount: number
         *   discountedAmount: number
         *   formattedDiscount: string
         *   formattedDiscountedAmount: string
         *   percentOff: string
         * } | null} coupon
         * @param {boolean=} clear
         */
        const couponChangeHandler = (coupon, clear = false) => {
          const rawOriginalAmount = Number(formAmountHiddenInput.value) / 100;
          const originalAmount = formatterCurrency.format(rawOriginalAmount);

          if (clear) {
            formCouponIdHiddenInput.value = "";
            formTotalAmountHiddenInput.value = formAmountHiddenInput.value;
            formDiscountAmountHiddenInput.value = "";
            formAmountOffHiddenInput.value = "";
            formPercentOffHiddenInput.value = "";

            couponElements.paymentTotalSpan.innerText = originalAmount;
            couponElements.discountAmountSpan.innerText = "";

            updateInstallments(rawOriginalAmount, formFixedInstallmentHiddenInput?.value === "true");
            return;
          } else if (coupon === null && formCouponIdHiddenInput.value) {
            if (timeoutRef !== null) {
              clearTimeout(timeoutRef);
            }
            timeoutRef = setTimeout(() => {
              couponForm.removeErrorSpan();
            }, 3000);
            return;
          } else if (coupon === null) {
            couponForm.appendErrorSpan();
            return;
          }

          couponForm.removeErrorSpan();

          formAmountOffHiddenInput.value = coupon.amountOff;
          formCouponIdHiddenInput.value = coupon.coupon;
          formDiscountAmountHiddenInput.value = coupon.discountAmount;
          formTotalAmountHiddenInput.value = coupon.discountedAmount;
          formPercentOffHiddenInput.value = coupon.percentOff;

          couponElements.paymentTotalSpan.innerText = coupon.formattedDiscountedAmount;
          couponElements.discountAmountSpan.innerText = coupon.formattedDiscount;

          updateInstallments(coupon.discountedAmount / 100, formFixedInstallmentHiddenInput?.value === "true");
        };
        couponForm.addCouponChangeListener(couponChangeHandler);
      }
    }
  }
  // END of Coupon Form
}

export function getPaymentInfoHelpers ({ from_cents } = { from_cents: false }) {
  const factor = from_cents ? 100 : 1;
  const productUnitAmountHiddenInput = document.getElementById("unit-amount") || document.getElementById("payment-total");
  const formAmountOffHiddenInput = document.getElementById("client_payment_amount_off");
  const formPercentOffHiddenInput = document.getElementById("client_payment_percent_off");

  function getUnitAmount () {
    return getValueWithoutFormat(productUnitAmountHiddenInput?.innerText) / factor;
  }

  function getDiscountAmount () {
    const percentDiscount = formPercentOffHiddenInput.value
      ? (getUnitAmount() * (+formPercentOffHiddenInput.value)) / 100
      : 0;
    const discountAmount = getValueWithoutFormat(formAmountOffHiddenInput.value)
      ? +getValueWithoutFormat(formAmountOffHiddenInput.value) / 100
      : percentDiscount;
    return discountAmount;
  }

  function getTotalAmount () {
    return getUnitAmount() - getDiscountAmount();
  }

  return { getUnitAmount, getDiscountAmount, getTotalAmount };
}
